// extracted by mini-css-extract-plugin
export default {"AccountActivationCardHeader__container":"dZ4Ys2Nvcy","AccountActivationCardHeader__jsqIcon":"qeS1Lilq0y"};